import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid m-0" }
const _hoisted_2 = { class: "col-12 mb-0 flex justify-content-center" }
const _hoisted_3 = { class: "font-light mb-0 mt-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Posts tagged ")
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Internal error ")
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "col-12 mb-0 flex justify-content-center border-bottom-1 border-200 pt-0 pb-10" }
const _hoisted_9 = { class: "grid m-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "xl:col-3" }, null, -1)
const _hoisted_11 = { class: "p-0 col-12 xl:col-6" }
const _hoisted_12 = { class: "flex flex-column border-right-1 border-left-1 border-bottom-1 border-300" }

import { useRoute } from "vue-router";
import gql from "graphql-tag";
import { useQuery } from "@vue/apollo-composable";
import NavBar from "@/components/NavBar.vue";
import PostList from "@/components/post/PostList.vue";
import { ref, watch } from "@vue/runtime-core";
import router from "../router";


export default /*#__PURE__*/_defineComponent({
  emits: ["on-router-view-reload"],
  setup(__props, { emit }) {



const route = useRoute();
const currentPage = parseInt(route.query.p?.[0]!)
const rowsPerPage = parseInt(localStorage.getItem("postNbOption") || '25');

if (isNaN(currentPage) || currentPage < 1) {
  router.push(`/tags/${route.params.tag}?p=1`);
}

const variables = ref({
  tag: route.params.tag,
  limit: rowsPerPage,
  offset: (currentPage - 1) * rowsPerPage,
});

const { loading, result, error, refetch } = useQuery(
  gql`
    query getPostsByTag($tag: String!, $limit: Int!, $offset: Int!) {
      post_aggregate(where: { post_tags: { tag: { name: { _eq: $tag } } } }) {
        aggregate {
          count
        }
      }
      post(
        order_by: { created_at: desc }
        where: { post_tags: { tag: { name: { _eq: $tag } } } }
        limit: $limit
        offset: $offset
      ) {
        url
        uuid
        created_at
        description
        title
        user {
          id
          username
        }
        comments_aggregate {
          aggregate {
            count
          }
        }
        post_tags(order_by: {tag: {name: asc}}) {
          tag {
            name
          }
        }
        bookmarks {
          uuid
        }
      }
    }
  `,
  variables,
  {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  }
);

watch(result, (value) => {
  if (
    value &&
    currentPage >
    Math.ceil(value.post_aggregate.aggregate.count / rowsPerPage)
  ) {
    router.push({ params: { p: 1 } });
  }
});

const changePage = ({ page }: { page: number }) => {
  router.push(`/tags/${route.params.tag}?p=${page + 1}`);
};

const updatePostNb = () => {
  emit('on-router-view-reload')
}

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(route).params.tag), 1)
        ])
      ])
    ]),
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "spinner"
        }))
      : (_unref(error))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "mt-5",
            severity: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : (_unref(result))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_unref(result).post_aggregate.aggregate.count) + " post" + _toDisplayString(_unref(result).post_aggregate.aggregate.count !== 1 ? "s" : ""), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Paginator, {
                      first: variables.value.offset,
                      totalRecords: _unref(result).post_aggregate.aggregate.count,
                      rows: _unref(rowsPerPage),
                      onPage: _cache[0] || (_cache[0] = ($event: any) => (changePage($event)))
                    }, null, 8, ["first", "totalRecords", "rows"]),
                    _createVNode(PostList, {
                      posts: _unref(result).post,
                      onOnRefresh: _unref(refetch),
                      onOnPostNbChange: updatePostNb
                    }, null, 8, ["posts", "onOnRefresh"]),
                    _createVNode(_component_Paginator, {
                      first: variables.value.offset,
                      totalRecords: _unref(result).post_aggregate.aggregate.count,
                      rows: _unref(rowsPerPage),
                      onPage: _cache[1] || (_cache[1] = ($event: any) => (changePage($event)))
                    }, null, 8, ["first", "totalRecords", "rows"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})